// ?? not ||: an explicitly empty value means "use relative URLs" (CRA dev proxy).
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? 'https://harmoniqsys.com';

export const AUTH_ENDPOINTS = {
  login: '/api/v1/auth/login',
  refresh: '/api/v1/auth/refresh',
  logout: '/api/v1/auth/logout',
};

export const STORAGE_KEYS = {
  authUser: 'CREW_CORE_AUTH_USER',
  theme: 'CREW_CORE_THEME',
  locale: 'CREW_CORE_LOCALE',
  textSize: 'CREW_CORE_TEXT_SIZE',
};

// Device preferences, not session data: logout leaves these alone.
STORAGE_KEYS.keepOnLogout = [STORAGE_KEYS.theme, STORAGE_KEYS.locale, STORAGE_KEYS.textSize];

export const APP_CONSTANTS = {
  appName: 'Crew Core',
};

export const PROJECT_ENDPOINTS = {
  listProjects: '/api/v1/project',
  listTasks: '/api/v1/project/tasks',
};

export const Timesheet_Endpoints = {
  listTimesheets: '/api/v1/timesheet/list',
  createTimesheet: '/api/v1/timesheet/create',
  updateTimesheet: '/api/v1/timesheet/update',
  deleteTimesheet: '/api/v1/timesheet/delete',
};
